import moment from 'moment';

export const formatDate = (
  date: Date | string | null,
  format = 'YYYY-MM-DDTHH:mm:ss'
) => {
  if (!date) return '';
  const formatted = moment(date).format(format);
  if (formatted === 'Invalid date') return '';
  return formatted;
};
